module.exports = __webpack_public_path__ + "media/images/twitter-icon@3x-49043c03e1ac2f2e292883b29e7e8402.png";